import React from "react";
import "./home.scss";
import logo from "../../images/logo.png";
import CleanNav from "../CleanNav/CleanNav";
import FooterFixed from "../FooterFixed/FooterFixed";

const Home = (props) => {
  return (
    <div>
      <CleanNav/>
      <div className="home-logo col-md-12 text-center mb-4">
      <a className="navbar-brand" href="/home">
        <img src={logo} height="56" alt="logo" width="150" />
        </a>
      </div>

      <div className="input-group mx-auto search-bar">
        <input className="form-control" placeholder="Search" onKeyDown={props.handleEnter} value={props.searchInput}  onChange={props.handleChange} />
        <span className="input-group-text btn-home-search" onClick={props.handleSearch}>
          <span className="fa fa-search icon" ></span>
        </span>
      </div>

      <div className="d-sm-flex justify-content-center mt-2 home-search-links">
        <p><b>Try</b></p>

        {props.suggestionsData.map((name,index) => (  
          <p className="suggestionstext" key={index} value={name} onClick={()=>props.clickSuggestion(name)}> 
            {name}  
            </p>  
        ))}  
      </div>
      <FooterFixed/>
    </div>
  );
};

export default Home;
